export default "__VITE_PUBLIC_ASSET__3cc0cc42__"